import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import FeaturedListsTable from './Table';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedListsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            lists: [],
            listQueryObject: {
                limit: 'none',
                featured: true,
                sort: 'featured',
            },
        };
    }
    componentDidMount() {
        this.loadLists();
    }
    loadLists = () => {
        return this.props.getLists( this.state.listQueryObject )
        .then( ( lists ) => {
            this.setState( ( altState ) => {
                altState.fetching= false,
                altState.lists = altState.lists.concat( lists ),
                altState.listQueryObject.page++;
                return altState;
            } );
            return lists;
        } );
    }
    listUpdated = ( index, list ) => {
        this.setState( ( altState ) => {
            if( list.featured == null ) {
                altState.lists = altState.lists.slice( 0, index ).concat( altState.lists.slice( index + 1 ) );
            } else {
                altState.lists[ index ] = list;
                altState.lists = altState.lists.slice( 0 );
            }
            return altState;
        } );
    }
    listDeleted = ( index ) => {
        this.setState( ( altState ) => {
            altState.lists = altState.lists.slice( 0, index ).concat( altState.lists.slice( index + 1 ) );
            return altState;
        } );
    }
    onManualSort = ( o, s, data ) => {
        var lists = [ ...this.state.lists ];
        var movedList = lists.splice( data.oldIndex, 1 )[ 0 ];
        lists.splice( data.newIndex, 0, movedList );
        var orderedListIds = lists.map( list => list.listid );
        this.props.updateFeaturedListOrder( orderedListIds );

        this.setState( { lists: lists } );
    }



    render() {
        const { fetching, lists } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Lists</h2>
                    <div className={ style.controls }>
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/lists' className={ style.tabOption }>View All</Link>
                        <Link to='/admin/lists/featured' className={ style.tabOption }
                        data-active={ true }>Featured Lists</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.featuredList }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <FeaturedListsTable lists={ lists }
                            onListUpdated={ this.listUpdated }
                            onListDeleted={ this.listDeleted }
                            onSort={ this.onManualSort } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getLists: ( queryObject ) => {
            return dAPI.get( '/admin/lists', queryObject );

        },
        updateFeaturedListOrder: ( newOrder ) => {
            return dAPI.patch( '/admin/lists/orderFeatured', { orderedListIds: newOrder } );

        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedListsView );
